import { extendObservable, runInAction } from 'mobx';

import { HomeController } from '../../../networking/controllers/HomeController';
import { Logger } from '../../../helpers/Logger';

class HomeStoreClass {
  constructor() {
    extendObservable(this, {
      homeData: null,
    });
  }

  async fetchHome() {
    try {
      const homeData = await HomeController.all();
      runInAction(() => {
        this.homeData = homeData;
      });
    } catch (error) {
      Logger.warn(error);
    }
  }
}

const HomeStore = new HomeStoreClass();

export { HomeStore };



// WEBPACK FOOTER //
// ./src/pages/home/stores/HomeStore.js